module.exports = __webpack_public_path__ + "img/107.523487b4.png";